import { render, staticRenderFns } from "./MyPoints.vue?vue&type=template&id=527d6556&scoped=true"
import script from "./MyPoints.vue?vue&type=script&lang=js"
export * from "./MyPoints.vue?vue&type=script&lang=js"
import style0 from "./MyPoints.vue?vue&type=style&index=0&id=527d6556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527d6556",
  null
  
)

export default component.exports